import React from 'react';
import {
    BASE_HOLDERS,
    BASE_HOLDER_LABELS,
    CALL_MODES,
    CALL_MODE_LABELS,
    STATES,
} from '../domain/constants';

// Lo switch del banditore: come esce il prossimo giocatore, e di chi e' la sua
// base d'asta.
//
// Sta fuori dalle impostazioni dell'asta, che sono bloccate mentre il timer
// scorre, perche' e' proprio durante un'asta che si decide di cambiare modo.
// Il cambio non tocca il lotto in corso: il server estrae solo entrando nello
// stato di chiamata, quindi vale dalla chiamata successiva da se'.
//
// Nessun componente switch o casella di spunta esiste in questa interfaccia:
// il pattern per una scelta fra poche voci e' il gruppo di bottoni, lo stesso
// dei filtri del listone e del passaggio Asta/Listone.

function Segmented({ label, value, options, labels, onPick }) {
    return (
        <div className="field">
            <span className="field-label">{label}</span>
            <div className="btn-group" role="group" aria-label={label}>
                {options.map((option) => (
                    <button
                        key={option}
                        type="button"
                        className={`btn btn--sm ${
                            value === option ? 'btn--primary' : 'btn--ghost'
                        }`}
                        aria-pressed={value === option}
                        onClick={() => onPick(option)}
                    >
                        {labels[option]}
                    </button>
                ))}
            </div>
        </div>
    );
}

export default function CallModeSwitch({ callMode, baseHolder, auctionState, onChange }) {
    const isFree = callMode === CALL_MODES.FREE;

    return (
        <section className="panel panel--quiet call-mode">
            <div className="panel-body call-mode-body">
                <Segmented
                    label="Chiamata"
                    value={callMode}
                    options={[
                        CALL_MODES.FREE,
                        CALL_MODES.RANDOM,
                        CALL_MODES.FVM,
                        CALL_MODES.ALPHA,
                    ]}
                    labels={CALL_MODE_LABELS}
                    onPick={(value) => onChange({ call_mode: value })}
                />
                {/* In chiamata libera la base e' per forza di chi chiama: la
                    domanda si pone solo quando il giocatore lo estrae il server. */}
                {!isFree && (
                    <Segmented
                        label="Base d'asta"
                        value={baseHolder}
                        options={[BASE_HOLDERS.NOBODY, BASE_HOLDERS.TURN]}
                        labels={BASE_HOLDER_LABELS}
                        onPick={(value) => onChange({ base_holder: value })}
                    />
                )}
            </div>
            {auctionState === STATES.BIDDING && (
                <p className="field-hint call-mode-hint">
                    L&apos;asta in corso non cambia: vale dalla chiamata successiva.
                </p>
            )}
        </section>
    );
}
